<template>
  <div class="page_israGud">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs" v-if="activeName=='first'">
          <div class="screenInput">
            <div class="flname">参保地区</div>
            <!-- <el-input v-model="listQuery.RegisteredAddress" size="small" clearable @keyup.enter.native="searchHandle"></el-input> -->
            <el-cascader ref="regAddress" :props="propsAddress" v-model="RegisteredAddress" placeholder="" :options="provinces" clearable filterable @change="changeAddress" @clear="clearAddress"></el-cascader>
          </div>
          <div class="screenInput">
            <div class="flname">公司名称</div>
            <el-input v-model="listQuery.CompanyName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">社保户</div>
            <el-select v-model="listQuery.IsSsaccount" size="small" placeholder="" clearable>
              <el-option value="有"></el-option>
              <el-option value="无"></el-option>
            </el-select>
          </div>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
        <div class="screenInputs" v-else>
          <div class="screenInput">
            <div class="flname">商保方案名称</div>
            <el-input v-model="listQuery2.ProjectName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">商保类别</div>
            <el-select v-model="listQuery2.Bntype" size="small" placeholder="" clearable>
              <el-option v-for="(item, index) in bntList" :key="index" :value="item"></el-option>
            </el-select>
          </div>
          <div class="screenInput">
            <div class="flname">工种类型</div>
            <el-select v-model="listQuery2.TypeWork" size="small" placeholder="" clearable>
              <el-option value="一类"></el-option>
              <el-option value="二类"></el-option>
              <el-option value="三类"></el-option>
              <el-option value="四类"></el-option>
              <el-option value="五类"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen==-1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="公积金户:">
            <el-select v-model="listQuery.IsAfund" size="small" placeholder="" clearable>
              <el-option value="有"></el-option>
              <el-option value="无"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="类型:" label-width="68px">
            <el-select v-model="listQuery.a" size="small" placeholder="" clearable>
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item> -->

        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item>
          <el-breadcrumb-item>保险维护</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="社保" name="first"></el-tab-pane>
          <!-- <el-tab-pane label="商保" name="second"></el-tab-pane> -->
        </el-tabs>
        <div style="margin-bottom: 10px;">
          <el-button type="success" size="small" @click="addIsra('')">&nbsp;新增</el-button>
        </div>
        <el-table v-if="activeName == 'first'" :data="tableData" style="width: 99%" border :max-height="tableHeight-100" class="doc_table" v-loading="loading">
          <el-table-column prop="SerialNumber" label="序号" width="50" align="center">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="CompanyName" label="公司全称" width="180" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="SsType" label="类型" width="100" align="center">
          </el-table-column>
          <el-table-column prop="RegisteredAddress" label="参保地区" width="180" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              {{ scope.row.RegisteredAddress ? scope.row.RegisteredAddress.split('/')[0].replace(/,/g,'-') : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="IsSsaccount" label="社保户" width="100" align="center">
          </el-table-column>
          <el-table-column prop="Ssrecipient" label="社保对接人" width="100" align="center">
            <template slot-scope="{row}">
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <span class="greenName cp" slot="reference" @click="getPhone(row.SsrecipientId)" v-show="row.SsrecipientId && row.Ssrecipient" title="点击查看联系方式">{{row.Ssrecipient}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="SspayTime" label="社保缴纳时间" width="100" align="center">
            <template slot-scope="scope">
              每月{{scope.row.SspayTime}}日
            </template>
          </el-table-column>
          <el-table-column prop="IsAfund" label="公积金户" width="100" align="center">
          </el-table-column>
          <el-table-column prop="AfundRecipient" label="公积金对接人" width="100" align="center">
            <template slot-scope="{row}">
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <span class="greenName cp" slot="reference" @click="getPhone(row.AfundRecipientId)" v-show="row.AfundRecipient && row.AfundRecipientId" title="点击查看联系方式">{{row.AfundRecipient}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="IsAfundPayTime" label="公积金缴纳时间" width="120" align="center">
            <template slot-scope="scope">
              每月{{scope.row.IsAfundPayTime}}日
            </template>
          </el-table-column>
          <el-table-column prop="IsAfund" label="社保文件" width="100" align="center">
            <template slot-scope="scope">
              <span class="info_item_sys cp" v-if="scope.row.SsAccountUrl" @click="down(scope.row.SsAccountUrl)">下载</span>
            </template>
          </el-table-column>
          <el-table-column prop="IsAfund" label="公积金文件" width="100" align="center">
            <template slot-scope="scope">
              <span class="info_item_sys cp" v-if="scope.row.IsAfundUrl" @click="down(scope.row.IsAfundUrl)">下载</span>
            </template>
          </el-table-column>
          <el-table-column prop="InjuryPolicyUrl" label="工伤政策" width="100" align="center">
            <template slot-scope="scope">
              <span class="info_item_sys cp" v-if="scope.row.InjuryPolicyUrl" @click="down(scope.row.InjuryPolicyUrl)">下载</span>
            </template>
          </el-table-column>
          <el-table-column prop="InjuryContacter" label="工伤对接人" width="100" align="center">
            <template slot-scope="{row}">
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <span class="greenName cp" slot="reference" @click="getPhone(row.InjuryContacterid)" v-show="row.InjuryContacterid && row.InjuryContacter" title="点击查看联系方式">{{row.InjuryContacter}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="InvalidenrenteUrl" label="残保金" width="100" align="center">
            <template slot-scope="scope">
              <span class="info_item_sys cp" v-if="scope.row.InvalidenrenteUrl" @click="down(scope.row.InvalidenrenteUrl)">下载</span>
            </template>
          </el-table-column>
          <el-table-column prop="PayInsuranceWages" label="发放派遣员工工资" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Explain" label="说明" width="200" align="center" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="name" label="操作" width="140" align="center" fixed="right">
            <template slot-scope="scope">
              <span class="info_item_sys cp" @click="addIsra(scope.row)">编辑</span>
              <el-popconfirm title="请确认是否作废？" v-if="checkPermission(['israGudSet_del'], permissionLists)" @confirm="del(scope.row)" style="margin: 0 10px;">
                <span slot="reference" class="info_item_sys cp" style="margin-left: 10px;">删除</span>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-table v-if="activeName == 'second'" :data="tableData2" style="width: 1331px" border :max-height="tableHeight-100" class="doc_table" v-loading="loading">
          <el-table-column prop="SerialNumber" label="序号" width="50" align="center">
            <template slot-scope="scope">
              {{(listQuery2.pageNum - 1) * Number(listQuery2.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="ProjectName" label="商保方案名称" width="180" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Bntype" label="商保类别" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="TypeWork" label="工种类型" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Price" label="投保金额（元）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ClaimsPrice" label="理赔上限（元）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ServerName" label="服务商" width="140" align="center" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="ContactPerson" label="对接人" width="100" align="center">
            <template slot-scope="{row}">
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <span class="greenName cp" slot="reference" @click="getPhone(row.ContactPersonId)" v-show="row.ContactPersonId && row.ContactPerson" title="点击查看联系方式">{{row.ContactPerson}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="Remark" label="说明" width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="附件" width="80" align="center">
            <template slot-scope="{row}">
              <span class="info_item_sys cp" v-if="row.AttachmentUrl" @click="down(row.AttachmentUrl)">下载</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <span class="info_item_sys cp" @click="addIsra(scope.row)">编辑</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisiblePic">
      <img width="100%" style="max-width: 1000px;" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: 0,
        showDropScreen: -1, //筛选下拉框 
        listQuery: {
          CompanyName: '',
          RegisteredAddress: '',
          IsSsaccount: '',
          IsAfund: '',
          pageNum: 1,
          pageSize: "10"
        },
        listQuery2: { //商保参数
          ProjectName: '', //商保方案名称
          Bntype: '', //商保类别
          TypeWork: '', //工种类型
          pageNum: 1,
          pageSize: "10"
        },
        tableData2: [], //商保数据
        totalCount: 0,
        permissionLists:[],
        scaleList: [],
        tableData: [{
          name: 'aaa',
          address: 'adsad'
        }],
        activeName: 'first',
        dialogVisiblePic: false,
        dialogImageUrl: '',
        headPath: this.$store.state.EMP.docPath,
        gridData: [], //联系方式表格
        gridloading: false,
        loading: false,
        provinces: [], //省市区
        propsAddress: {
          label: "Name",
          value: "Name",
          children: "children",
          checkStrictly: true
        },
        RegisteredAddress: [],
        bntList: ['30万小商保', '60万大商保', '90万大小商保', '50万商保（超龄人员保安保洁岗位）', '30万小商保（建筑业）', '60万大商保（建筑业）', '90万大小商保（建筑业）', '90万日商保（1-4类）', '100万雇主责任险', '30万新业态伤害险', '60万新业态伤害险', '90万新业态伤害险', '源和健康险']
      };
    },
    created() {
      this.calHeight();
      this.getsslist();
      this.getprovinces();
      this.getButtonPower();
    },
    methods: {
      checkPermission,
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
      },
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/israGudSet',
          powerEnName: 'doc'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      changeAddress(val) {
        // this.listQuery.RegisteredAddress = val[val.length - 1]
        // console.log(val, val[val.length - 1])
        this.listQuery.RegisteredAddress = val.toString();
        this.$refs.regAddress._data.dropDownVisible = false;
      },
      clearAddress() {
        this.RegisteredAddress = []
        this.listQuery.RegisteredAddress = ''
      },
      //获取省市区
      getprovinces() {
        xz.getAreaAll().then((res) => {
          this.provinces = res
        })
      },
      //获取社保列表
      getsslist() {
        this.loading = true;
        xz.getsslist(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.$message.error('系统出错')
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.searchHandle();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.searchHandle();
      },
      // 清空
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery;
        this.listQuery.pageNum = 1;
        this.listQuery.pageNum = '10';
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      // //查看图片
      // showImg(url) {
      //   this.dialogImageUrl = this.headPath + url;
      //   this.dialogVisiblePic = true;
      // },
      searchHandle() {
        if (this.activeName == 'first') {
          this.getsslist()
        } else {
          this.getbIlist();
        }
      },
      //查看详情
      toDdetail() {
        this.$router.push({
          path: '/legalSubjectInfo'
        })
      },
      handleClick() {
        if (this.activeName == 'second') {
          this.getbIlist();
        } else {
          this.getsslist();
        }
      },
      addIsra(row) {
        let path = this.activeName == 'first' ? '/addSsy' : '/addCIn';
        this.$router.push({
          path: path,
          query: {
            row: row ? JSON.stringify(row) : ''
          },
        });
      },
      //获取商保列表
      getbIlist() {
        this.loading = true;
        xz.getbIlist(this.listQuery2).then(res => {
          if (res.status == 'ok') {
            this.tableData2 = res.data.data;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.$message.error('系统出错')
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      down(url) {
        let d = url.replace("\"", "").replace("\"", "");
        var path = this.headPath + d;
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click();
      },
      getPhone(id) {
        this.gridData = [];
        this.gridloading = true;
        let dtlQuery = {
          mainuserid: '',
          useridr: id
        }
        xz.getauthJbUserDetail(dtlQuery).then(res => {
          if (res.status == 'ok') {
            this.gridData = [{
              phone: res.msg.Strmobile
            }]
            this.gridloading = false;
          } else {
            this.$message.error('获取联系方式失败')
            this.gridData = []
            this.gridloading = false;
          }
        })

      },
      del(row) {
        if (!this.loading) {
          this.loading = true;
          xz.delSocialSecurity(row.Id).then(res => {
            if (res.status == 'ok') {
              this.$message.success("删除成功！");
              this.getsslist();
              this.loading = false;
            } else {
              this.$message.error(res.msg);
              this.getsslist();
              this.loading = false;
            }
          })
        }
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_item_sys {
    color: #598DE7;
  }
</style>
<style>
  .page_israGud .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #c0c4cc;
  }

  .page_israGud .el-table .descending .sort-caret.descending {
    border-top-color: #c0c4cc;
  }

  .page_israGud .th_input_label .el-form-item__label {
    width: 66px !important;
  }

  .page_israGud .el-form-item__label {
    padding: 0 5px 0 0;
  }

  .page_israGud .el-tabs {
    background-color: #fff;
    padding: 0 10px;
  }

  .page_israGud .screenInputs .screenInput {
    margin: 0 0 10px 5px;
  }

  .page_israGud .screenInputs .screenInput .el-select .el-input__inner,
  .page_israGud .re_down_form.el-form--inline .el-form-item__content,
  .page_israGud .re_down_form .el-select,
  .page_israGud .re_down_form .el-form-item__content,
  .page_israGud .screenInput .el-input {
    width: 200px !important;
  }

  /* .doc_table.el-table .cell {
    padding: 0 5px;
  } */

  .page_israGud .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_israGud .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }


  .page_israGud .r_dropDownScreen .el-select .el-input .el-select__caret {
    line-height: 40px;
  }

  .page_israGud .el-cascader .el-input .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
</style>